import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ADMIN_API_URL } from "../../config/config";
import { User } from "../../models/user.model";
import { AngularFirestore } from "@angular/fire/firestore";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(public http: HttpClient, private afs: AngularFirestore) {}

  getAll() {
    return this.afs.collection("users").get().toPromise();
  }

  getUsers(hashkey: any) {
    const url = ADMIN_API_URL + "/users";
    return this.http.get(url);
  }

  getUsersAFS(lastItem: any) {
    return this.afs
      .collection("users", (ref) =>
        ref.orderBy("cdate", "desc").limit(20).startAfter(lastItem)
      )
      .get();
  }

  getUserCount() {
    return this.afs.collection("dbRefs").doc("users").valueChanges();
  }

  searchUserByEmail(searchKey: string) {
    return this.afs
      .collection("users", (ref) =>
        ref
          .where("email", ">=", searchKey)
          .where("email", "<=", searchKey + "\uf8ff")
      )
      .get();
  }

  searchUserByDikeffId(searchKey: any) {
    var x: number = +searchKey;
    return this.afs
      .collection("users", (ref) => ref.where("dikeffId", "==", x))
      .get();
  }

  activateDeactivateUser(uid: any, isActiveFromAdmin: boolean) {
    const userData = {
      isActive: isActiveFromAdmin,
    };
    return this.afs.collection("users").doc(uid).set(userData, {
      merge: true,
    });
  }

  activateDeactivateGoldUser(uid: any, isActiveFromAdmin: boolean) {
    const userData = {
      isGoldPlan: isActiveFromAdmin,
    };
    return this.afs.collection("users").doc(uid).set(userData, {
      merge: true,
    });
  }

  putUsers(user: User) {
    console.log(user);
    const userData = {
      dikeffId: user.dikeffId,
      referralId: user.referralId,
    };
    return this.afs.collection("users").doc(user.uid).set(userData, {
      merge: true,
    });
  }
}
